import React from "react";
import img1 from "../../../assets/images/secure_data.png";
import img2 from "../../../assets/images/functional.png";
import img3 from "../../../assets/images/live-chat.png";
import img4 from "../../../assets/images/support.png";
import img5 from "../../../assets/images/features_frame.png";

const Main = ({ video }) => {
  return (
    <>
      {
        <section className="row_am features_section" id="features">
          <div className="container">
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="100"
            >
              <h2>
                <span>Features</span> That Make Our App Unique
              </h2>
              <p>
                myFit integrates seamlessly into your life to help you and your
                family achieve your health goals, <br />
                whether it's improving fitness, maintaining health, or
                encouraging your family or group..
              </p>
            </div>
            <div className="feature_detail">
              <div className="left_data feature_box">
                <div
                  className="data_block"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div className="text">
                    <h4>Health Statistics</h4>
                    <p>
                      Easily track your health statistics, including weight
                      changes, blood pressure, blood glucose, and other data
                      specific to your needs.{" "}
                    </p>
                  </div>
                </div>
                <div
                  className="data_block"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div className="text">
                    <h4>Reminders</h4>
                    <p>
                      Never miss an appointment, medication schedule, or other
                      important tasks with myFit reminders. Allow your provider
                      to set reminders, or set them up yourself for anything you
                      need.
                    </p>
                  </div>
                </div>
              </div>
              <div className="right_data feature_box">
                <div
                  className="data_block"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div className="text">
                    <h4>Family Connect</h4>
                    <p>
                      Share, encourage, remind, or check in with your connected
                      family or group. myFit offers engaging, easy-to-use Family
                      Connect features that keep everyone informed and
                      connected.
                    </p>
                  </div>
                </div>
                <div
                  className="data_block"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div className="text">
                    <h4>Health Goals</h4>
                    <p>
                      Your health plan, your way—myFit assists you in organizing
                      your prescriptions, health routines, and your provider’s
                      treatment plans all in one place.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="feature_img"
                data-aos="fade-up"
                data-aos-duration="1500"
                data-aos-delay="100"
              >
                <img src={img5} alt="image" />
              </div>
            </div>
          </div>
        </section>
      }
    </>
  );
};

export default Main;
